import { normalizeRoot } from "./designerUtils";
import { normalizeColorCode, normalizeColorObject } from "./designerHelpers";

export const adaptMasterTree = (masterTree) => normalizeRoot(masterTree);

const getColorConsumptionTotal = (color) => {
    const numeric = Number(color?.consumption_total ?? color?.consumption ?? 0);
    return Number.isFinite(numeric) ? numeric : 0;
};

const sortColors = (colors = []) =>
    [...(colors || [])].sort((a, b) => {
        const consumptionDelta = getColorConsumptionTotal(b) - getColorConsumptionTotal(a);
        if (consumptionDelta !== 0) return consumptionDelta;
        const nameA = String(a?.name || "");
        const nameB = String(b?.name || "");
        const byName = nameA.localeCompare(nameB, "es", { sensitivity: "base" });
        if (byName !== 0) return byName;
        return String(a?.id || "").localeCompare(String(b?.id || ""), "es", { sensitivity: "base" });
    });

export const adaptAllColorsResponse = (response) =>
    sortColors((response?.colors || []).map((color) => ({
        ...color,
        code: normalizeColorCode(color.code),
        color_charts: sortColors((color.color_charts || []).map((chart) => ({
            ...chart,
            code: normalizeColorCode(chart.code),
        }))),
    })));

export const adaptAvailableColorsResponse = (response) =>
    sortColors((response?.colors || []).map((color) => normalizeColorObject(color)));

export const adaptPrintDetailsResponse = (response) =>
    (response?.prints || []).map((print) => print);
